import authAxios from 'modules/shared/axios/authAxios';
import { AuthToken } from 'modules/auth/authToken';

export default class AuthService {
  static async sendEmailVerification() {
    const response = await authAxios.post(
      '/auth/send-email-address-verification-email',
    );

    return response.data;
  }

  static async sendPasswordResetEmail(email, recoveryMethod) {
    const response = await authAxios.post(
      '/auth/send-password-reset-email',
      {
        email,
        method: recoveryMethod
      },
    );

    return response.data;
  }

  static async getPasswordResetMethod(email) {
    const response = await authAxios.post(
      '/auth/get-password-reset-method',
      {
        email,
      },
    );

    return response.data;
  }

  static async registerWithEmailAndPassword(
    email,
    password,
  ) {
    const response = await authAxios.post('/auth/sign-up', {
      email,
      password,
    });

    return response.data;
  }

  static async signinWithEmailAndPassword(email, password) {
    const response = await authAxios.post('/auth/sign-in', {
      email,
      password,
    });

    return response.data;
  }

  static async signinWithEmailAndPasswordV2(email, password, rememberMe) {
    const response = await authAxios.post(
      '/auth/sign-in-v2',
      {
        email,
        password,
        rememberMe,
      },
      { withCredentials: true },
    );

    return response.data;
  }

  static async refresh() {
    const response = await authAxios.post('/auth/refresh', null, { withCredentials: true });
    return response.data;
  }

  static async fetchMe() {
    const response = await authAxios.get('/auth/me');
    return response.data;
  }

  static async isEmailConfigured() {
    const response = await authAxios.get(
      '/auth/email-configured',
    );
    return response.data;
  }

  static async signout() {
    try {
      await authAxios.post('/auth/sign-out', null, { withCredentials: true });
    } catch (error) {}

    AuthToken.set(null, true);
  }

  static async updateProfile(
    firstName,
    lastName,
    phoneNumber,
    avatars,
  ) {
    const body = {
      profile: {
        firstName,
        lastName,
        phoneNumber,
        avatars,
      },
    };

    const response = await authAxios.put(
      '/auth/profile',
      body,
    );

    return response.data;
  }

  static async passwordReset(token, password) {
    const response = await authAxios.put(
      '/auth/password-reset',
      {
        token,
        password,
      },
    );

    return response.data;
  }

  static async verifyEmail(token) {
    const response = await authAxios.put(
      '/auth/verify-email',
      {
        token,
      },
    );

    return response.data;
  }

  static async changePassword(oldPassword, newPassword) {
    const response = await authAxios.put('/auth/change-password', {
      oldPassword,
      newPassword
    })

    return response.data;
  }
}
